import React from "react";
import { Box, Typography, Button, Dialog, Input } from "@mui/material";
import LandingPageBg from "../assets/images/LandingPageBg.png";
import { useState } from "react";
import { useSnackbar } from "notistack";
import { addDoc, collection } from "firebase/firestore";
import { firestore } from "../firebase";
import SubscribeRedesign from "./component/SubscibeRedesign";

export default function LandingPage() {
  const [subscribeDialog, setSubscribeDialogState] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [email, setEmail] = useState("");

  return (
    <>
      <Dialog
        sx={{ borderRadius: '0px 0px 0px 0px'}}
        open={subscribeDialog}
        onClose={() => setSubscribeDialogState(false)}
      >
        <Box padding="20px" >
          <SubscribeRedesign 
            setSubscribeDialogState={setSubscribeDialogState}
            onCloseIconClick={() => setSubscribeDialogState(false)}
          />
        </Box>
      </Dialog>

      <Box
        sx={{
          minHeight: "90vh",
          backgroundImage: `url(${LandingPageBg})`,
          backgroundSize: "cover",
          "& p": {
            color: "white",
            textAlign: "center",
          },
          "& .main": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            minHeight: "90vh",
            width: "min(75%, 50rem)",
            marginX: "auto",
          },
          "& button": {
            color: "white",
            border: "1px solid white",
            borderRadius: "0",
            padding: ".8rem 3rem",
          },
        }}
      >
        <Box className="main">
          <Box>
            <Box
              className="logo"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={72}
                height={60}
                viewBox="0 0 72 60"
                fill="none"
              >
                <path
                  d="M22.6879 0C24.2254 0 25.5083 0.000282377 26.8428 0.000564754V7.0662C23.2591 7.0662 19.5928 7.06535 16.5346 7.06535C11.5329 7.54144 7.72274 11.7277 7.72274 16.7557C7.72274 22.1341 12.0584 26.4788 17.4368 26.4903H26.8428V33.5099H17.4574C12.0708 33.5099 7.72274 37.8583 7.72246 43.2449C7.72246 48.2712 11.53 52.4563 16.5301 52.9346H32.49V0.00197664H54.5917C63.8159 0.0290848 71.2972 7.5324 71.2972 16.7565C71.2972 21.9596 68.8792 26.843 64.8011 30.0011C68.8789 33.1592 71.2972 38.0427 71.2972 43.2457C71.2972 52.0037 64.5322 59.2963 55.7989 59.9528C55.381 59.9845 54.9619 60 54.5429 60H45.1575V52.9352H55.4699C60.4697 52.4569 64.2775 48.2718 64.2775 43.2454C64.2775 37.8588 59.9292 33.5108 54.5426 33.5108C51.1558 33.5108 48.1685 33.5099 45.1575 33.5099V26.4898C48.428 26.4898 51.7736 26.4906 54.5635 26.4906C59.9419 26.479 64.2775 22.1344 64.2775 16.756C64.2775 11.728 60.4674 7.54172 55.4657 7.06563H39.5099V59.9997H16.597V59.9734C16.4651 59.9667 16.3333 59.961 16.2017 59.9511C7.46832 59.2952 0.703125 52.0025 0.703125 43.2446C0.703125 38.0415 3.1214 33.1581 7.19921 30C3.1214 26.8419 0.703125 21.9585 0.703125 16.7554C0.703125 7.53127 8.18471 0.0279553 17.4086 0.000847131H17.4105C18.886 0 20.3535 0 21.8266 0H22.6879Z"
                  fill="#DAA520"
                />
              </svg>
            </Box>
            <Box className="heading">
              <Typography
                sx={{
                  textTransform: "capitalize",
                  fontSize: "2rem",
                  fontWeight: "500",
                  marginTop: "1rem",
                }}
              >
                connecting Worlds, Bridging Divides.
              </Typography>
            </Box>
          </Box>
          <Box className="p1" sx={{ marginY: "2rem" }}>
            <Typography>
              <span style={{ fontWeight: "700", fontSize: "1.5rem" }}>
                {" "}
                Luxury collectibles marketplace launching soon
              </span>{" "}
              - Be among the first to
              <Typography />get your hands on physical curated
              collections that come with identical virtual
              <Typography/>representatives
              (IVR™).
            </Typography>
          </Box>
          <Box className="p2">
            <Typography>
              Oh and did we mention that IVRs will be the keys to unlocking the
              whole new big beyond experience,
              <Typography/>which blurs the line between the
              virtual and the real world so hard
              <Typography/>you will not be able to put
              your phone down?
            </Typography>
          </Box>
          <Box
            className="button"
            sx={{ display: "flex", justifyContent: "center" , marginY:"2rem"}}
          >
            <Button
              variant="outlined"
              sx={{ textTransform: "uppercase" }}
              onClick={() => setSubscribeDialogState(true)}
            >
              Get Early access
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={36}
                height={20}
                viewBox="0 0 36 20"
                fill="none"
                style={{ marginLeft: "1rem" }}
              >
                <path
                  d="M25.7714 0L24.0907 1.68077L31.2215 8.81157H0.228027V8.81165V11.1886V11.1887H31.2212L24.0907 18.3192L25.7714 20L35.7716 10L25.7714 0Z"
                  fill="white"
                />
              </svg>
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
}
